export default __webpack_public_path__ + "static/media/qrcode-play-store.a1ea1aaa.svg";